import { useCallback, useMemo } from 'preact/compat';
import { isAfter, parse } from 'date-fns';
export default function useLowAvailabilityDates(lowAvailability, highAvailability, averageAvailability, soldOut = []) {
    // console.log('useLowAvailabilityDates', lowAvailability);
    const filteredDates = useCallback((dates) => dates.filter((givenDate) => {
        const parsedDate = parse(givenDate, 'yyyy-MM-dd', new Date());
        return isAfter(parsedDate, new Date());
    }), []);
    const averageAvailabilityDates = useMemo(() => {
        const givenDates = averageAvailability || [];
        return filteredDates(givenDates);
    }, [averageAvailability]);
    const highAvailabilityDates = useMemo(() => {
        const givenDates = highAvailability || [];
        return filteredDates(givenDates);
    }, [highAvailability]);
    const lowAvailabilityDates = useMemo(() => {
        const givenDates = lowAvailability || [];
        return filteredDates(givenDates);
    }, [lowAvailability]);
    const soldOutDates = useMemo(() => {
        const givenDates = soldOut || [];
        return filteredDates(givenDates);
    }, [soldOut]);
    return useMemo(() => ({
        lowAvailabilityDates,
        averageAvailabilityDates,
        highAvailabilityDates,
        soldOutDates,
    }), [
        lowAvailabilityDates,
        averageAvailabilityDates,
        highAvailabilityDates,
        soldOutDates,
    ]);
}
